export default __webpack_public_path__ + "static/media/avatar-author.1d6e71c3.svg";